import queryString from 'query-string';
import constants from '../constants';

export default function apiService(url, method, params) {
  let fetchParams = {
    method,
    headers:  {
      'Accept': 'application/json; version=1.0',
      'Content-Type': 'application/json'
    }
  };
  if (method !== 'GET') {
    fetchParams.body = JSON.stringify(params);
  }
  if (method === 'GET') {
    if (params) {
      url += '?'
    }
    url += queryString.stringify(params);
  }
  return fetch(`${constants.API}${url}`, fetchParams)
}



// WEBPACK FOOTER //
// ./src/lib/apiService.js